import { render } from "./cart-summary.vue?vue&type=template&id=05f5e1f4"
import script from "./cart-summary.vue?vue&type=script&lang=js"
export * from "./cart-summary.vue?vue&type=script&lang=js"

import "./cart-summary.vue?vue&type=style&index=0&id=05f5e1f4&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__